import { API } from '../api';
import axiosInstance from '../axiosConfig';
export const getSquarePayLocations = async (locationId) => {
  const response = await axiosInstance.get(API.OAUTH.GET_ALL_SQUARE_PAY_LOCATION + locationId);
  return response.data?.data;
};
export const createPaymentAccount = async (body) => {
  const response = await axiosInstance.post(API.OAUTH.CREATE_SQUARE_PAYMENT_ACCOUNT, body);
  return response.data;
};
export const bindSquareLocation = async (id, locationId) => {
  const response = await axiosInstance.get(API.OAUTH.BIND_SQUARE_LOCATION + id + '/' + locationId);
  return response;
};
export const isSquareConnected = async (locationId) => {
  const response = await axiosInstance.get(API.OAUTH.CHECK_SQUARE_CONNECTED + locationId);
  return response;
};
export const disconnectSquarePay = async (locationId) => {
  const response = await axiosInstance.delete(API.OAUTH.DISCONNECT_SQUARE + locationId);
  return response;
};

export const isPaymentConnected = async (locationId) => {
  const response = await axiosInstance.get(API.OAUTH.CHECK_PAYMENT_PROVIDER + locationId);
  return response;
};

export const connectStripe = async (locationId, country) => {
  let body = {
    locationId: locationId,
    country: country
  };
  const response = await axiosInstance.post(API.OAUTH.CONNECT_STRIPE, body);
  return response;
};

export const isGoogleCalendarConnected = async (locationId, businessId) => {
  const response = await axiosInstance.get(
    API.OAUTH.CHECK_GOOGLE_CALENDAR_CONNECTED + locationId + '/' + businessId
  );
  return response;
};
export const disconnectGoogleCalendar = async (locationId, businessId) => {
  const response = await axiosInstance.get(
    API.OAUTH.DISCONNECT_GOOGLE_CALENDAR + locationId + '/' + businessId
  );
  return response;
};

export const isMicrosoftConnected = async (locationId, businessId) => {
  const response = await axiosInstance.get(
    API.OAUTH.CHECK_MICROSOFT_CONNECTED + locationId + '/' + businessId
  );
  return response;
};
export const disconnectMicrosoftCalendar = async (locationId, businessId) => {
  const response = await axiosInstance.get(
    API.OAUTH.DISCONNECT_MICROSOFT_CALENDAR + locationId + '/' + businessId
  );
  return response;
};

export const checkCurrentPaymentgateWay = async (locationId) => {
  const response = await axiosInstance.get(API.OAUTH.CHECK_CURRENT_ACCOUNT + locationId);
  return response;
};

export const createStripeIntent = async (body) => {
  const response = await axiosInstance.post(API.OAUTH.STRIPE_INTENT, body);
  return response;
};

export const disconnectPayment = async (id, locationId, provider) => {
  const response = await axiosInstance.delete(
    API.OAUTH.DISCONNECT_PAYMENT_ACCOUNT + id + '/' + locationId + '/' + provider
  );
  return response;
};
